import make, { Enum } from '@xaamin/enum';

class ProviderCancellation extends Enum {
  name = 'ProviderCancellation';

  enum = {
    enabled: 1,
    disabled: 0,
    undefined: 33,
  };
}

export default make(ProviderCancellation);
